import { render } from "./UrocretePage.vue?vue&type=template&id=4e9ba8b8"
import script from "./UrocretePage.vue?vue&type=script&lang=js"
export * from "./UrocretePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__